import { motion } from "framer-motion";
import { RevealLines, ParallaxImage, EASE } from "./motion";
import { ConceptBadge } from "./Badges";

export const PageHero = ({ eyebrow, lines, intro, img, alt, badge = "Sample page · Concept preview", children, testId }) => (
  <section data-testid={testId} className="relative mx-auto grid max-w-[1440px] items-center gap-10 px-5 pt-28 lg:grid-cols-12 lg:px-12 lg:pt-40">
    <div className="lg:col-span-5">
      <ConceptBadge label={badge} />
      <p className="eyebrow mb-5 mt-8">{eyebrow}</p>
      <RevealLines className="font-display text-5xl font-bold leading-[0.98] tracking-tight text-white sm:text-6xl xl:text-7xl" lines={lines} />
      <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, ease: EASE, delay: 0.4 }} className="mt-7 text-base leading-relaxed text-slate-200 md:text-lg">{intro}</motion.p>
      {children}
    </div>
    <motion.div initial={{ opacity: 0, clipPath: "inset(12% 12% 12% 12% round 2rem)" }} animate={{ opacity: 1, clipPath: "inset(0% 0% 0% 0% round 2rem)" }} transition={{ duration: 1.4, ease: EASE, delay: 0.15 }} className="lg:col-span-7">
      <ParallaxImage src={img} alt={alt} className="aspect-[16/11] rounded-[2rem] glow-edge" strength={7} />
    </motion.div>
  </section>
);
